import moment from "moment";

export default {
  data() {
    return {
      date_format: 'DD.MM.YYYY, HH:mm',
    }
  },
  methods: {
    formatted_date(date) {
      return moment(date).format(this.date_format);
    }
  }
}
